import request from '#/utils/request';
import { withFmsActor } from '#/api/fmsMgmt/fmsActorConfig';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { toVoucherWriteBody } from './serialize';

/**
 * POST `/fms/vouchers` → 201。
 * 可送 totalAmount；禁送 status。
 */
export async function createVoucher(payload) {
  const { data: raw } = await request.post(
    '/fms/vouchers',
    toVoucherWriteBody(payload),
    withFmsActor(),
  );
  return parseVer4DetailResponse(raw);
}
